<template>
  <section class="section" :class="{ tint }">
    <div class="wrap">
      <div class="section-head reveal">
        <p class="eyebrow">Kind words</p>
        <h2>Loved by the families we build for</h2>
      </div>

      <div class="rev-summary reveal">
        <GoogleLogo class="g-logo" />
        <div class="rev-score">
          <strong>{{ rating.toFixed(1) }}</strong>
          <div class="stars" :aria-label="`${rating} out of 5 stars`">★★★★★</div>
          <small>Based on {{ count }} Google {{ count === 1 ? "review" : "reviews" }}</small>
        </div>
        <a :href="reviewUrl" target="_blank" rel="noopener" class="btn btn-primary">See all reviews</a>
      </div>

      <div class="rev-grid">
        <article v-for="(r, i) in reviews" :key="r.name" class="rev-card reveal">
          <div class="rev-top">
            <div class="avatar" :style="{ background: avatarColor(i) }">{{ r.name.charAt(0) }}</div>
            <div class="rev-meta">
              <h4>{{ r.name }}</h4>
            </div>
            <GoogleLogo class="g-badge" />
          </div>
          <p class="rev-text" :class="{ clamped: !expanded[i] }">{{ r.text }}</p>
          <button v-if="isLong(r.text)" type="button" class="rev-more" @click="toggle(i)">
            {{ expanded[i] ? "Show less" : "Read more" }}
          </button>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import GoogleLogo from "@/components/GoogleLogo.vue";

// Real reviews from EIKA's Google listing.
// Individual star ratings and dates aren't recorded here — Google shows an
// overall 4.9, but we don't know which review is the 4-star one, so per-card
// stars are intentionally omitted rather than guessed.
const REVIEWS = [
  {
    name: "Lee JingRu",
    text: `Being first-time homeowners, my husband and I were often unsure of what to do throughout the renovation process. We are truly grateful to our interior designer, Jia Qing from Eika Interiors, who guided us every step of the way with patience and professionalism. He took the time to understand our needs and designed the dream home we had always envisioned.

We are absolutely delighted with the final outcome and couldn't be happier with our beautiful home. Thank you, Jia Qing, for making this journey such a smooth and enjoyable one. We will definitely recommend Eika Interiors to anyone looking to renovate their new home!`,
  },
  {
    name: "Sean Ng",
    text: `Working with Eika Interiors was an absolute pleasure. Jia Qing has the rare ability to recommend practical designs that not only complement your personal taste but also elevate the overall aesthetic of your space. His patience and clear communication made the entire process smooth and enjoyable, while his keen eye for detail ensured that every element aligned perfectly with my vision. The workmanship delivered was above market standards, and the quotation provided was both fair and reasonable. What stood out most was his trustworthiness and commitment — he was willing to make adjustments and refinements until I was fully satisfied. That level of dedication is rare in the industry. Eika Interiors truly has the ability to bring your vision to life, blending functionality with beauty in a way that feels effortless. I would highly recommend his services to anyone looking for a reliable, talented, and professional interior designer.`,
  },
  {
    name: "Bing",
    text: `Working with Eika Interior has been such a pleasant experience from start to finish. The team was thoughtful, patient, and genuinely cared about bringing my ideas to life. I would like to thank Jia Qing especially for listening closely to what I wanted and for making the whole process feel smooth and reassuring.

What I appreciated most was their eye for detail, creativity, and the amount of care they put into every part of the project. You can really feel their passion in the work they do. The final outcome turned out beautifully, and I'm truly grateful for their dedication and effort. I would gladly recommend Eika Interior to anyone looking for a team that is not only talented, but also sincere and wonderful to work with.`,
  },
  {
    name: "Bernice Sidik",
    text: `Jia Qing was professional, responsive, and easy to work with throughout the project. He managed to bring the design concept to life in a practical and well-executed way.

He was closely involved in the material selection, as well as the purchase of sanitary fittings and accessories for our bathrooms. Overall, his input made the renovation process smoother, and the final result turned out very close to what we had in mind.`,
  },
  {
    name: "Bingqian Lee",
    text: `Thank you to Eika for making my renovation journey stress free! Jia Qing was extremely responsive and prompt in his replies throughout the process. He was able to advise me on making the design choices I wanted and bring my vision to life. Thank you!`,
  },
  {
    name: "Jonas Ng",
    text: `We had the pleasure of working with EIKA Interiors on several projects, and their level of detail and professionalism has always been top-notch. Every design was intentional, with spaces thoughtfully planned to ensure both aesthetics and functionality.

Their attention to detail, communication, and commitment to quality made the entire process smooth and enjoyable. It's evident that they truly care about delivering well-executed spaces tailored to their clients' needs. We highly recommend EIKA Interiors to anyone looking for a reliable and thoughtful interior design firm.`,
  },
  {
    name: "Herbert Sidik",
    text: `Bernice & Jia Qing did an amazing job working on our BTO project. Everything went really smoothly and communication was great.

Would definitely recommend them for their workmanship & professionalism!`,
  },
  {
    name: "Chan ShiJie",
    text: `Friendly service and very patient with first time home owners. Outcome is just as I envisioned! Will recommend to everyone!`,
  },
];

const AVATAR_COLORS = ["#b5714f", "#8a917c", "#a8613f", "#b79c7d", "#6f7a63", "#9c6247"];

export default {
  name: "GoogleReviews",
  components: { GoogleLogo },
  props: {
    tint: { type: Boolean, default: false },
  },
  data() {
    return {
      rating: 4.9,
      count: 8,
      reviewUrl: "https://maps.app.goo.gl/pb8EnUbWe3JtAJVw6",
      reviews: REVIEWS,
      expanded: {},
    };
  },
  methods: {
    avatarColor(i) {
      return AVATAR_COLORS[i % AVATAR_COLORS.length];
    },
    isLong(text) {
      return text.length > 240;
    },
    toggle(i) {
      this.expanded = { ...this.expanded, [i]: !this.expanded[i] };
    },
  },
};
</script>
